{
  "name": "client-app",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build-prod": "ng build --configuration=production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@abacritt/angularx-social-login": "^2.3.0",
    "@angular/animations": "^19.2.4",
    "@angular/cdk": "^19.2.7",
    "@angular/common": "^19.2.4",
    "@angular/compiler": "^19.2.4",
    "@angular/core": "^19.2.4",
    "@angular/forms": "^19.2.4",
    "@angular/material": "^19.2.7",
    "@angular/material-moment-adapter": "^19.2.7",
    "@angular/platform-browser": "^19.2.4",
    "@angular/platform-browser-dynamic": "^19.2.4",
    "@angular/router": "^19.2.4",
    "@ctrl/ngx-emoji-mart": "^9.3.0",
    "@ngx-translate/core": "^15.0.0",
    "@types/node": "^22.13.17",
    "bootstrap": "^5.3.3",
    "moment": "^2.29.4",
    "ng2-pdf-viewer": "^10.0.0",
    "ngx-editor": "^18.0.0",
    "raygun4js": "^2.25.6",
    "rxjs": "^7.8.2",
    "save": "^2.9.0",
    "tslib": "^2.3.0",
    "zone.js": "^0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.5",
    "@angular/cli": "~19.2.5",
    "@angular/compiler-cli": "^19.2.4",
    "@types/jasmine": "~4.0.0",
    "jasmine-core": "~4.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.0.0",
    "typescript": "^5.8.2"
  }
}
